import { Formik } from "formik";
import {
  MimaButton,
  MimaDropdown,
  MimaText,
  Modal,
  PageLoader,
} from "../../components";
import moment from "moment";
import { billsStore } from "../../stores";

const ReconBillsModal = ({
  loading,
  closeModal,
  billItem,
  confirmRecon,
  setConfirmRecon,
  reconHandler,
  goBack,
  validationSchema,
  onSubmit,
  statusData,
}) => {
  return (
    <Modal closeModal={closeModal} goBack={goBack}>
      {loading ? (
        <PageLoader loading={loading} />
      ) : (
        <>
          {!confirmRecon ? (
            <MimaText variant="subtitleBold" mb={2}>
              Bill Details
            </MimaText>
          ) : (
            <MimaText variant="subtitleBold" mb={4}>
              Reconcile Bill
            </MimaText>
          )}

          {!confirmRecon && (
            <div style={{ width: "38rem" }}>
              <MimaText labelTitle="Business Name" mb={1}>
                {billItem.business.tradingName}
              </MimaText>
              <MimaText labelTitle="Created At" mb={1}>
                {moment(billItem.createdAt).format("DD/MM/YY hh:mm A")}
              </MimaText>
              <MimaText labelTitle="Bill Type" mb={1}>
                {billItem.bill.type}
              </MimaText>
              <MimaText labelTitle="Vendor" mb={1}>
                {billItem.bill.vendor}
              </MimaText>
              {billItem.bill.type !== "TV-SUBSCRIPTION" && (
                <MimaText labelTitle="Phone number" mb={1}>
                  {billItem.bill.phone}
                </MimaText>
              )}
              <MimaText labelTitle="Amount" mb={1}>
                {billItem.bill.amount}
              </MimaText>
              {billItem.bill.type === "AIRTIME" && (
                <MimaText labelTitle="Network" mb={1}>
                  {billItem.bill.networkId}
                </MimaText>
              )}
              {billItem.bill.type === "ELECTRICITY" && (
                <>
                  <MimaText labelTitle="Meter number" mb={1}>
                    {billItem.bill.meterNumber}
                  </MimaText>
                  <MimaText labelTitle="DISCO" mb={1}>
                    {billItem.bill.categoryName}
                  </MimaText>
                </>
              )}
              {billItem.bill.type === "TV-SUBSCRIPTION" && (
                <>
                  <MimaText labelTitle="Cable TV Name" mb={1}>
                    {billItem.bill.cableTvName}
                  </MimaText>
                  <MimaText labelTitle="Cable TV Customer" mb={1}>
                    {billItem.bill.customerName}
                  </MimaText>
                  <MimaText labelTitle="Smart Card Number" mb={1}>
                    {billItem.bill.smartCardNo}
                  </MimaText>
                  <MimaText labelTitle="Cable TV Plan" mb={1}>
                    {billItem.bill.plan}
                  </MimaText>
                </>
              )}
              {billItem.bill.type === "DATA" && (
                <MimaText labelTitle="Data Plan" mb={1}>
                  {billItem.bill.plan}
                </MimaText>
              )}
              {billItem.status === "PENDING" && (
                <MimaButton
                  title="Reconcile Bill"
                  width={38}
                  mt={2}
                  onClick={() => {
                    setConfirmRecon(true);
                    billsStore.setSelectedBill(billItem);
                  }}
                />
              )}
            </div>
          )}

          {confirmRecon && (
            <div style={{ width: "38rem" }}>
              <MimaText align="center" mb={3}>
                Kindly select status for bill reconciliation.
              </MimaText>
              <Formik
                initialValues={{
                  status: "",
                }}
                onSubmit={onSubmit}
                validationSchema={validationSchema}
              >
                {({
                  handleBlur,
                  handleChange,
                  handleSubmit,
                  setFieldValue,
                  values,
                  errors,
                  touched,
                }) => (
                  <>
                    <MimaDropdown
                      labelTitle="Status"
                      placeholder="Select status"
                      name="status"
                      data={statusData}
                      value={values.status}
                      id="status"
                      onChange={(data) => {
                        setFieldValue("status", data.key);
                      }}
                      error={errors.status}
                      touched={touched.status}
                    />
                    <div className="modal__beside">
                      <MimaButton
                        width={18}
                        title="Confirm"
                        buttonColor="var(--color-primary)"
                        onClick={handleSubmit}
                        mt={2}
                      />
                      <MimaButton
                        width={18}
                        title="Go back"
                        buttonColor="var(--color-error)"
                        onClick={() => setConfirmRecon(false)}
                        mt={2}
                      />
                    </div>
                  </>
                )}
              </Formik>
            </div>
          )}
        </>
      )}
    </Modal>
  );
};
export default ReconBillsModal;
